module.exports = __webpack_public_path__ + "static/img/tinysite-determine.c620f4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tinysite-determine.png
// module id = k7cc
// module chunks = 208